"use client";

import "./CustomWebAppSection.scss";
import ImageSwiperSection from "@/components/ImageSwiperSection/ImageSwiperSection";

const CustomWebAppSection = ({ data }) => {

  const { title, subtitle, features } = data;
  
  return (
    <ImageSwiperSection
      title={title}
      description={subtitle}
      items={features}
    />
  );
};

export default CustomWebAppSection;
